import script from "./Book.vue?vue&type=script&lang=ts&setup=true"
export * from "./Book.vue?vue&type=script&lang=ts&setup=true"

import "./Book.vue?vue&type=style&index=0&id=1abc863d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1abc863d"]])

export default __exports__